<div class="container">
  <p class="title">
   Sailing Performance  <mat-icon class="titleIcon">chevron_right</mat-icon> Commercial
    Performance
    <mat-icon class="titleIcon">chevron_right</mat-icon> Periodic Report
  </p>
  <div class="text-right">
    <button
      class="btn btn-light hover-button mail periodic"
      (click)="tableClick()"
    >
      <mat-icon>assignment</mat-icon> Periodic Report Table
    </button>
    <button
      class="btn btn-light hover-button mail"
      (click)="uploadfile()"
      [disabled]="!requestForm.valid"
    >
      <mat-icon>file_upload</mat-icon>Upload File
    </button>
    <input
      type="file"
      hidden
      #fileInput
      (change)="onFileSelected($event)"
      accept=".xlsx, .xls , .xlsm, .csv"
    />
    <button class="btn btn-light hover-button mail" (click)="clearClick()">
      <mat-icon>clear_all</mat-icon> &nbsp;Clear
    </button>
    <button class="btn btn-light hover-button mail" (click)="submitClick()">
      <mat-icon>done</mat-icon> Save
    </button>
  </div>
  <div class="bgv">
    <form [formGroup]="requestForm">
      <div class="row foddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for="">Use New Current Formula:</label>
        </div>
        <div class="col-md-8 radioButton">
          <app-custom-radio-button
            [options]="yesNo"
            [controlname]="this.requestForm.controls['useNewCurrentFormula']"
          ></app-custom-radio-button>
        </div>
      </div>
      <div class="row foddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""><span class="asterik-color">*</span>MerakiPic:</label>
        </div>

        <div class="col-md-8 textBox dropDown">
          <select
            formControlName="merakiPic"
            class="form-control"
            [ngClass]="{
              'error-border':
                formSubmitted &&
                requestForm.get('merakiPic')?.hasError('required')
            }"
          >
            <option
              *ngFor="
                let option of merakiPicOptions;
                even as isEven;
                odd as isOdd
              "
              [ngValue]="option.value"
              [ngClass]="{ odd: isOdd, even: isEven }"
            >
              {{ option.label }}
            </option>
          </select>

          <small
            class="error"
            *ngIf="
              formSubmitted &&
              requestForm.get('merakiPic')?.hasError('required')
            "
          >
            <p class="ename">MerakiPic is required.</p>
          </small>
        </div>
      </div>
      <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for="">Ship:</label>
        </div>
        <div class="col-md-8 textBox">
          <div class="row">
            <!-- Type of Ship -->
            <div class="col-md-6">
              <label class="repotedWeatherLabel">Type of ship</label>
              <select
                formControlName="typeOfShip"
                class="form-control"
                [ngClass]="{
                  'error-border':
                    formSubmitted &&
                    requestForm.get('typeOfShip')?.hasError('required')
                }"
              >
                <option
                  *ngFor="let option of typeofshipOptions"
                  [ngValue]="option.value"
                >
                  {{ option.label }}
                </option>
              </select>

              <small
                class="error"
                *ngIf="
                  formSubmitted &&
                  requestForm.get('typeOfShip')?.hasError('required')
                "
              >
                <p class="ename">Type of ship is required.</p>
              </small>
            </div>

            <!-- Segment -->
            <div class="col-md-6">
              <label class="repotedWeatherLabel">Segment</label>
              <select
                formControlName="segment"
                class="form-control"
                [ngClass]="{
                  'error-border':
                    formSubmitted &&
                    requestForm.get('segment')?.hasError('required')
                }"
              >
                <option
                  *ngFor="let seg of segmentOptions"
                  [ngValue]="seg.value"
                >
                  {{ seg.label }}
                </option>
              </select>
              <small
                class="error"
                *ngIf="
                  formSubmitted &&
                  requestForm.get('segment')?.hasError('required')
                "
              >
                <p class="ename">Segment is required.</p>
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""><span class="asterik-color"></span>Ship Yard:</label>
        </div>
        <div class="col-md-8 textBox">
          <div class="row">
            <!-- Ship Yard Input -->
            <div class="col-md-6">
              <label class="repotedWeatherLabel">Ship Yard</label>
              <app-custom-input
                [errorMessage]="'Ship Yard is required'"
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['shipYard']"
              ></app-custom-input>
            </div>

            <!-- Year Built Input -->
            <div class="col-md-6">
              <label class="repotedWeatherLabel">Year Built</label>
              <app-custom-input
                [errorMessage]="'Year Built is required'"
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['yearBuilt']"
              ></app-custom-input>
            </div>
          </div>
        </div>
      </div>

      <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for=""><span class="asterik-color">*</span>Client Name:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-dropdown
            [items]="clientOptions"
            [formSubmitted]="formSubmitted"
            [requiredErrorMessage]="' Client is required'"
            [controlname]="this.requestForm.controls['client']"
          ></app-custom-dropdown>
          <!-- <app-custom-input
              [formSubmitted]="formSubmitted"
              [controlname]="this.requestForm.controls['client']"
              [readonly]="true"
            ></app-custom-input> -->
        </div>
      </div>
      <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color">*</span>Weather Source:</label
          >
        </div>
        <div class="col-md-8 textBox dropDown">
          <select
            formControlName="weatherSource"
            class="form-control"
            [ngClass]="{
              'error-border':
                formSubmitted &&
                requestForm.get('weatherSource')?.hasError('required')
            }"
          >
            <option
              *ngFor="
                let option of weatherSourceOptions;
                even as isEven;
                odd as isOdd
              "
              [ngValue]="option.value"
              [ngClass]="{ odd: isOdd, even: isEven }"
            >
              {{ option.label }}
            </option>
          </select>
          <small
            class="error"
            *ngIf="
              formSubmitted &&
              requestForm.get('weatherSource')?.hasError('required')
            "
          >
            <p class="ename">Weather Source is required.</p>
          </small>
        </div>
      </div>

      <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color">*</span>Type of speed:</label
          >
        </div>
        <div class="col-md-8 radioButton">
          <app-custom-radio-button
            [options]="typeOfSpeedOptions"
            [controlname]="this.requestForm.controls['typeSpeed']"
          >
            ></app-custom-radio-button
          >
        </div>
      </div>

      <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color">*</span>Weather calculation:</label
          >
        </div>
        <div class="col-md-8 radioButton">
          <app-custom-radio-button
            [options]="wetherCalculationOptions"
            [controlname]="this.requestForm.controls['wetherCalculation']"
          ></app-custom-radio-button>
        </div>
      </div>
      <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for=""><span class="asterik-color">*</span>DSS Limit:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input
            [errorMessage]="'BF Limit DSS is required'"
            [formSubmitted]="formSubmitted"
            [controlname]="this.requestForm.controls['bfLimitDss']"
            (onInput)="numberInput($event, 'bfLimitDss')"
          ></app-custom-input>
        </div>
      </div>
      <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color">*</span>Wind Beaufort(BF):</label
          >
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input
            [errorMessage]="'Wind Beaufort is required'"
            [formSubmitted]="formSubmitted"
            [controlname]="this.requestForm.controls['windBeaufort']"
            (onInput)="numberInput($event, 'windBeaufort')"
          ></app-custom-input>
        </div>
      </div>

      <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color">*</span>Wind Wave(in meter):</label
          >
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input
            (onInput)="numberInput($event, 'windWave')"
            [errorMessage]="'Wind Wave is required'"
            [formSubmitted]="formSubmitted"
            [controlname]="this.requestForm.controls['windWave']"
          ></app-custom-input>
        </div>
      </div>

      <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color">*</span>Swell Height(DSS)(in
            meter):</label
          >
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input
            [errorMessage]="'Swell Heigh is required'"
            [formSubmitted]="formSubmitted"
            [controlname]="this.requestForm.controls['swellHeight']"
            (onInput)="numberInput($event, 'swellHeight')"
          ></app-custom-input>
        </div>
      </div>

      <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color">*</span>Significant Wave(in
            meter):</label
          >
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input
            [errorMessage]="'Significant Wave is required'"
            [formSubmitted]="formSubmitted"
            [controlname]="this.requestForm.controls['significantWave']"
            (onInput)="numberInput($event, 'significantWave')"
          ></app-custom-input>
        </div>
      </div>

      <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color">*</span>Adverse current
            excluded?:</label
          >
        </div>

        <div class="col-md-8 radioButton">
          <app-custom-radio-button
            [options]="adverseCurrentValue"
            [controlname]="this.requestForm.controls['adverseCurrent']"
          ></app-custom-radio-button>
        </div>
      </div>

      <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color">*</span>Current factor:</label
          >
        </div>
        <div class="col-md-8 radioButton">
          <app-custom-radio-button
            [options]="yesNo"
            [controlname]="this.requestForm.controls['currentFactor']"
          ></app-custom-radio-button>
        </div>
      </div>
      <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color" *ngIf="weatherFactor">*</span>Weather
            factor:</label
          >
        </div>
        <div class="col-md-8 radioButton">
          <app-custom-radio-button
            [options]="weatherfactorOptions"
            [controlname]="this.requestForm.controls['weatherFactor']"
          ></app-custom-radio-button>
        </div>
      </div>
      <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color">*</span>Periodic current factor(3
            Hourly):</label
          >
        </div>
        <div class="col-md-8 radioButton">
          <app-custom-radio-button
            [options]="yesNo"
            [controlname]="this.requestForm.controls['periodiccurrentfactor']"
          ></app-custom-radio-button>
        </div>
      </div>

      <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color">*</span>Good weather period defined as
            per C/P:</label
          >
        </div>
        <div class="col-md-8 textBox">
          <div class="row">
            <div class="col-md-6">
               <app-custom-input (onInput)="numberInput($event, 'goodWeatherPeriod')"
                [controlname]="this.requestForm.controls['goodWeatherPeriod']"></app-custom-input>
              <!-- <app-custom-dropdown
                [items]="goodWeatherPeriod"
                [requiredErrorMessage]="
                  'Good weather period defined as per C/P is required'
                "
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['goodWeatherPeriod']"
              ></app-custom-dropdown> -->
            </div>
            <div class="col-md-6 checkBox">
              <mat-checkbox
                class="example-margin"
                id="hoursNeedToBeCon"
                formControlName="hoursNeedToBeCon"
                color="primary"
                ><span class="checkboxLabel">Hours Need To Be Continuous</span></mat-checkbox
              >
            </div>
          </div>
        </div>
      </div>
      <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for="">24 Hours Positive:</label>
        </div>
        <div class="col-md-8 radioButton">
          <app-custom-radio-button
            [options]="yesNoDayPositive"
            [controlname]="this.requestForm.controls['allDayPositive']"
          ></app-custom-radio-button>
        </div>
      </div>
      <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color">*</span>Performance calculation:</label
          >
        </div>
        <div class="col-md-8 radioButton">
          <app-custom-radio-button
            [options]="performanceCalOptions"
            [controlname]="this.requestForm.controls['performanceCal']"
          ></app-custom-radio-button>
        </div>
      </div>

      <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for=""><span class="asterik-color">*</span>About S&C:</label>
        </div>
        <div class="col-md-8 radioButton">
          <app-custom-radio-button
            [options]="yesNo"
            [controlname]="this.requestForm.controls['aboutSc']"
          ></app-custom-radio-button>
        </div>
      </div>
      <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color">*</span>About Speed Min
            Tolerence(minus):</label
          >
        </div>
        <div class="col-md-8 textBox">
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                [errorMessage]="'About Speed Min Tolerence is required'"
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['speedMinTol']"
                (onInput)="numberInput($event, 'speedMinTol')"
              ></app-custom-input>
            </div>

            <div class="col-md-6 checkBox">
              <mat-checkbox
                class="example-margin"
                id="minPercentage"
                formControlName="speedMinTolPercentage"
                color="primary"
                ><span class="checkboxLabel">Percentage</span></mat-checkbox
              >
            </div>
          </div>
        </div>
      </div>

      <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color">*</span>About Speed Max
            Tolerence(plus):</label
          >
        </div>

        <div class="col-md-8 textBox">
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                [errorMessage]="'About Speed Max Tolerence is required'"
                [formSubmitted]="formSubmitted"
                [controlname]="this.requestForm.controls['speedMaxTol']"
                (onInput)="numberInput($event, 'speedMaxTol')"
              ></app-custom-input>
            </div>
            <div class="col-md-6 checkBox">
              <mat-checkbox
                class="example-margin"
                id="maxPercentage"
                formControlName="speedMaxTolPercentage"
                color="primary"
                ><span class="checkboxLabel">Percentage</span></mat-checkbox
              >
            </div>
          </div>
        </div>
      </div>

      <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color">*</span>About Cons Min Tolerence(minus)
            as %:</label
          >
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input
            [errorMessage]="'About Cons Min Tolerence as % is required'"
            [formSubmitted]="formSubmitted"
            [controlname]="this.requestForm.controls['consMinTol']"
            (onInput)="numberInput($event, 'consMinTol')"
          ></app-custom-input>
        </div>
      </div>

      <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color">*</span>About Cons Max Tolerence(plus)
            as %:</label
          >
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input
            [errorMessage]="'About Cons Max Tolerence as % is required'"
            [formSubmitted]="formSubmitted"
            [controlname]="this.requestForm.controls['consMaxTol']"
            (onInput)="numberInput($event, 'consMaxTol')"
          ></app-custom-input>
        </div>
      </div>

      <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color">*</span>Extrapolation method:</label
          >
        </div>
        <div class="col-md-8 radioButton">
          <app-custom-radio-button
            [options]="yesNo"
            [controlname]="this.requestForm.controls['extrapolationMethod']"
          ></app-custom-radio-button>
        </div>
      </div>

      <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color">*</span>MGO AE Cons Exculded</label
          >
        </div>
        <div class="col-md-8 radioButton">
          <app-custom-radio-button
            [options]="duelFuelOptions"
            [controlname]="this.requestForm.controls['duelFuel']"
          ></app-custom-radio-button>
        </div>
      </div>
      <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for=""
            ><span class="asterik-color"></span>Cp Ordered Consumption
            GO:</label
          >
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input
            [formSubmitted]="formSubmitted"
            [controlname]="this.requestForm.controls['cpGasOil']"
            (onInput)="numberInput($event, 'cpGasOil')"
          ></app-custom-input>
        </div>
      </div>
      <div class="row mainevenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label for="" class="mainCp">Main C/P:</label>
        </div>
        <div class="col-md-8 textarea">
          <textarea
            [ngClass]="{
              invalid:
                formSubmitted && this.requestForm.controls['mainCp'].invalid
            }"
            id="mainCp"
            name="mainCp"
            class="form-control"
            formControlName="mainCp"
          ></textarea>
          <div
            *ngIf="
              formSubmitted && this.requestForm.controls['mainCp']?.invalid
            "
            class="error-message"
          >
            <p
              class="ename"
              *ngIf="this.requestForm.controls['mainCp']?.errors?.['required']"
            >
              Main C/P is required
            </p>
            <p
              *ngIf="this.requestForm.controls['mainCp']?.errors?.['maxWordsExceeded']"
              class="ename"
            >
              Main C/P is required Only 1500 words
            </p>
          </div>
        </div>
      </div>
      <div class="row oddLastBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label for="">Any Additional Comments:</label>
        </div>
        <div class="col-md-8 textarea">
          <textarea
            id="additionalComments"
            name="additionalComments"
            class="form-control"
            formControlName="additionalComments"
          ></textarea>
        </div>
      </div>
    </form>
  </div>
  <div class="text-right">
    <button class="btn btn-light hover-button mail" (click)="topClick()">
      <mat-icon>arrow_upward</mat-icon> &nbsp;Go top
    </button>

    <button class="btn btn-light hover-button mail" (click)="clearClick()">
      <mat-icon>clear_all</mat-icon> &nbsp;Clear
    </button>
    <button class="btn btn-light hover-button mail" (click)="submitClick()">
      <mat-icon>done</mat-icon> Save
    </button>
  </div>
  <br />
</div>
